import React, { useState, useEffect } from "react";
import { Grid, TextField } from "@mui/material";
import SliderAuth from "../../../components/SliderAuth/SliderAuth";
import Loader from "../../../components/Loader/Loader";
import { useNavigate } from "react-router-dom";
import { images } from "../../../config/images";
import { ValidatorForm } from "react-material-ui-form-validator";
import { Button } from "../../../components/Button/button";
import "./welcome.css";
import PrivacyPolicy from "../../../components/Privacy/Privacy";
import { verifyuser } from "../service";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Ensure CSS is imported

const LoginWithUserNameOrPassword = ({
    setEmail,
    setMobileNo,
    onNextClick
}) => {
    const navigate = useNavigate();

    const [isLoading, setLoading] = useState(false);
    const [formvalues, setFormvalue] = React.useState({
        username_mobno: "",
    });

    const [isEmailValid, setEmailValid] = useState(false);
    const [isMobileValid, setMobileValid] = useState(false);
    const handleChange = (e) => {
        setFormvalue({ ...formvalues, [e.target.name]: e.target.value });
    };
    // Update validity when form values change
    useEffect(() => {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const mobileRegex = /^[6-9]\d{9}$/;

        if (emailRegex.test(formvalues.username_mobno)) {
            setEmailValid(true);
            setMobileValid(false);
        } else if (mobileRegex.test(formvalues.username_mobno)) {
            setMobileValid(true);
            setEmailValid(false);
        } else {
            setEmailValid(false);
            setMobileValid(false);
        }
    }, [formvalues.username_mobno]);

    const notifyError = (message) => {
        toast.error(message, {
            theme: "colored",
            position: "top-right",
            toastClassName: "custom-toast",
        });
    };
    const notifySuccess = (message) => {
        toast.success(message, {
            theme: "colored",
            position: "top-right",
            toastClassName: "custom-toast",
        });
    };
    const handleLoginWithOtp = async () => {
        try {
            const params = {
                "mobile_no": `91${formvalues.username_mobno}` // Add 91 as a prefix
            }
            const resp = await verifyuser(params);
            if (resp.data.success == true) {
                setMobileNo(formvalues.username_mobno);
                onNextClick("loginWithOtp")
            } else {
                notifyError("No Active User")
            }

        } catch (error) {
            console.log("Error Verifying user", error);
            notifyError("No Active User");
        }
    };

    const handleLoginWithPassword = async () => {
        try {
            const params = {
                "username": formvalues.username_mobno
            }
            const resp = await verifyuser(params);
            if (resp.data.success == true) {
                setEmail(formvalues.username_mobno);
                onNextClick("loginWithPassword")
            } else {
                notifyError("No Active User")
            }

        } catch (error) {
            console.log("Error Verifying user", error);
            notifyError("No Active User");
        }

    };
    useEffect(() => {
        const savedUser = localStorage.getItem("user") || sessionStorage.getItem("user");

        if (savedUser) {
            const userData = JSON.parse(savedUser);
            console.log("savedUser", userData.email)

            setFormvalue((prevState) => ({
                ...prevState,
                username_mobno: userData.email || "", // Set the saved email, or an empty string if not present
            }));
        }
    }, []);
    return (
        <>
            <ToastContainer />
            <Grid container className="main-container">
                <SliderAuth />
                <Grid item xs={12} md={5} lg={4} className="signIn-form-wrap">
                    <div className="pb-2">
                        <img src={images.logo} alt="" className="signIn-logo" />
                    </div>
                    <h3 className="text-center singIn-title">Welcome</h3>
                    <ValidatorForm>
                        <TextField
                            id="filled-basic"
                            name="username_mobno"
                            label="Username/ Mobile No"
                            value={formvalues.username_mobno}
                            onChange={handleChange}
                            variant="filled"
                            validators={["required"]}
                            errorMessages={["This field is required"]}
                            style={{ width: "100%", backgroundColor: "#F4F7FE" }}
                            slotProps={{
                                inputLabel: {
                                    style: { color: "#011627", fontSize: "14px" },
                                },
                            }}
                        >
                        </TextField>
                        <div className="welcome-button">
                            <Button
                                classname={isMobileValid ? "custom-button" : "border-btn"}
                                title="Login With OTP"
                                onClick={() => { handleLoginWithOtp() }}
                                style={{
                                    marginRight: "8px",
                                    fontSize: "14px",
                                    border: isMobileValid ? "" : "none",
                                    backgroundColor: isMobileValid ? "#005AA6" : "#A9B0BD",
                                    cursor: isMobileValid ? "pointer" : "not-allowed",
                                }}
                                disabled={!isMobileValid}
                            />
                            <Button
                                classname={isEmailValid ? "custom-button" : "border-btn"}
                                title="Login With Password"
                                onClick={() => { handleLoginWithPassword() }}
                                style={{
                                    fontSize: "14px",
                                    border: isEmailValid ? "" : "none",
                                    backgroundColor: isEmailValid ? "#005AA6" : "#A9B0BD",
                                    cursor: isEmailValid ? "pointer" : "not-allowed",
                                }}
                                disabled={!isEmailValid}
                            />
                        </div>
                    </ValidatorForm>
                    <PrivacyPolicy />

                </Grid>
            </Grid>
            {isLoading && <Loader />}


        </>
    )
}

export default LoginWithUserNameOrPassword;